import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=bf100a40&scoped=true&"
import script from "./LandingFooter.vue?vue&type=script&lang=ts&"
export * from "./LandingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=bf100a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf100a40",
  null
  
)

export default component.exports